/**
 * Checks if two rectangles intersect.
 * @param {ClientRect} rect1 The first rectangle.
 * @param {ClientRect} rect2 The second rectangle.
 * @return {boolean} True if the rectangles intersect, false otherwise.
 */
export function intersects(rect1: DOMRect, rect2: DOMRect): boolean {
    return !(rect2.left > rect1.right ||
        rect2.right < rect1.left ||
        rect2.top > rect1.bottom ||
        rect2.bottom < rect1.top);
}
